/*
 * <pdp-ingredientes>: seção "O que tem dentro" do editorial da PDP v2 (tipo `ingredientes`
 * do snippets/biobio-pdp-conteudo.liquid).
 *
 * Contrato de markup gerado pelo snippet: um tablist [role="tablist"] (.pdp-ing__etiquetas)
 * sobre a foto, com um botão [data-ing-tab="1..n"] por ingrediente destaque, e um painel
 * [data-ing-painel="1..n"] por ingrediente abaixo da foto. O Liquid já entrega o estado
 * inicial (aba 1 com aria-selected="true", tabindex=0 e .is-ativo; só o painel 1 sem hidden),
 * então conectar não mexe em nada: sem JS, a cliente vê a foto, as etiquetas e o 1o ingrediente.
 *
 * Padrão WAI-ARIA de tabs com ativação automática (como a régua do <pdp-aplicacao>): um só
 * tabindex=0 no grupo; setas (com volta), Home e End movem o foco e já selecionam.
 *
 * Troca de aba não mexe em oferta, carrinho, URL nem galeria. Sem estado global.
 * Emite 'ingredientes:trocado' (detail.indice 1..n e detail.nome, bubbles) e
 * dataLayer.push({ event: 'pdp_v2_ingrediente', ingrediente: '<nome da etiqueta>' }).
 * Tocar na aba já ativa não reemite.
 *
 * Guard de registro no topo: o Shopify NÃO dedupa <script> por URL, e o snippet põe um
 * <script> por seção desse tipo.
 */
(function () {
  if (typeof window === 'undefined' || !window.customElements) return;
  if (window.customElements.get('pdp-ingredientes')) return;

  class PdpIngredientes extends HTMLElement {
    connectedCallback() {
      if (this._pronto) return;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-ing-tab]'));
      this.paineis = Array.prototype.slice.call(this.querySelectorAll('[data-ing-painel]'));
      if (!this.tabs.length || !this.paineis.length) return;
      this.lista = this.querySelector('[role="tablist"]') || this;

      this._abort = new AbortController();
      var sig = this._abort.signal;
      this.lista.addEventListener('click', this.aoClicar.bind(this), { signal: sig });
      this.lista.addEventListener('keydown', this.aoTeclar.bind(this), { signal: sig });
      this._pronto = true;
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      this._pronto = false;
    }

    indiceAtivo() {
      for (var i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].getAttribute('aria-selected') === 'true') return i;
      }
      return -1;
    }

    // i é a posição (0..n-1) na lista de abas. Devolve false quando a aba já era a ativa.
    marcar(i) {
      if (i < 0 || i >= this.tabs.length || i === this.indiceAtivo()) return false;
      var alvo = this.tabs[i].dataset.ingTab;
      this.tabs.forEach(function (t, j) {
        var ativo = j === i;
        t.setAttribute('aria-selected', ativo ? 'true' : 'false');
        t.tabIndex = ativo ? 0 : -1;
        t.classList.toggle('is-ativo', ativo);
      });
      this.paineis.forEach(function (p) {
        p.hidden = p.dataset.ingPainel !== alvo;
      });
      return true;
    }

    selecionar(i) {
      if (!this.marcar(i)) return false;
      var nome = String(this.tabs[i].textContent || '').trim();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'pdp_v2_ingrediente', ingrediente: nome });
      this.dispatchEvent(new CustomEvent('ingredientes:trocado', { detail: { indice: Number(this.tabs[i].dataset.ingTab), nome: nome }, bubbles: true }));
      return true;
    }

    abaDe(alvo) {
      var tab = alvo && alvo.closest ? alvo.closest('[data-ing-tab]') : null;
      return tab ? this.tabs.indexOf(tab) : -1;
    }

    aoClicar(e) {
      var i = this.abaDe(e.target);
      if (i < 0) return;
      this.selecionar(i);
    }

    aoTeclar(e) {
      // Alt/Ctrl/Cmd + seta sao atalhos do navegador (voltar, avancar): passam reto.
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      // A tecla vem da aba focada (o keydown borbulha dela até o tablist).
      var i = this.abaDe(e.target);
      if (i < 0) return;
      var novo = PdpIngredientes.proximoIndice(i, this.tabs.length, e.key);
      if (novo < 0) return;
      e.preventDefault();
      this.selecionar(novo);
      this.tabs[novo].focus();
    }

    static proximoIndice(i, n, k) {
      if (k === 'ArrowRight' || k === 'ArrowDown') return (i + 1) % n;
      if (k === 'ArrowLeft' || k === 'ArrowUp') return (i - 1 + n) % n;
      if (k === 'Home') return 0;
      if (k === 'End') return n - 1;
      return -1;
    }
  }

  window.customElements.define('pdp-ingredientes', PdpIngredientes);
})();
